export const permissionsRequiredMessages = {
  en: {
    title: 'Permissions Required',
    message: 'Unfortunately, you are not permitted to enter this page.',
    continueMessage: 'Continue here please.',
  },
};
